import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

// Décode le payload d'un JWT sans vérifier la signature (vérification côté serveur)
function decodeJwt(token) {
    try {
        const payload = token.split('.')[1];
        return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    } catch {
        return null;
    }
}

// Retourne true si le token est expiré ou invalide
function isTokenExpired(token) {
    const payload = decodeJwt(token);
    if (!payload || !payload.exp) return true;
    return Date.now() >= payload.exp * 1000;
}

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(null);
    const [authLoading, setAuthLoading] = useState(true);

    useEffect(() => {
        const savedToken = localStorage.getItem('onlineico_token');
        const savedUser  = localStorage.getItem('onlineico_user');

        if (savedToken && savedUser) {
            if (isTokenExpired(savedToken)) {
                // Token expiré → nettoyage et redirection vers login
                localStorage.removeItem('onlineico_token');
                localStorage.removeItem('onlineico_user');
                window.location.replace('/connexion');
            } else {
                setToken(savedToken);
                setUser(JSON.parse(savedUser));
            }
        }
        setAuthLoading(false);
    }, []);

    const loginUser = (userData, jwtToken) => {
        setUser(userData);
        setToken(jwtToken);
        localStorage.setItem('onlineico_token', jwtToken);
        localStorage.setItem('onlineico_user', JSON.stringify(userData));
    };

    const logoutUser = () => {
        setUser(null);
        setToken(null);
        localStorage.removeItem('onlineico_token');
        localStorage.removeItem('onlineico_user');
    };

    return (
        <AuthContext.Provider value={{ user, token, authLoading, loginUser, logoutUser }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}